module.exports = __webpack_public_path__ + "img/nunwardle-2e0dc18e-fac3-40f9-c3e3-08d94b66ac0f.png";